import { createReactComponent } from '@tabler/icons-react';

export const IconCustomArrowsCollapseVertical = createReactComponent(
  'outline',
  'customArrowsCollapseVertical',
  'CustomArrowsCollapseVertical',
  [
    [
      'path',
      {
        key: 'customArrowsCollapseVertical-path',
        d: 'M15.1,5.9l-3.1,3.1-3.1-3.1M8.9,18.2l3.1-3.1,3.1,3.1',
      },
    ],
  ]
);
